import { PAYMENT_TERMS } from './masters'
import {
  createSupplierApi,
  deleteSupplierApi,
  getSupplierApi,
  listSuppliersApi,
  setSupplierStatusApi,
  updateSupplierApi,
} from './apiClient'
import {
  categoriesFromFormats,
  supplierFormatService,
} from './supplierFormatService'
import type {
  GoodsCategory,
  PaymentTerm,
  Supplier,
  SupplierInput,
  SupplierStatus,
} from './types'

function liveCategories(): GoodsCategory[] {
  return categoriesFromFormats(supplierFormatService.getAll())
}

export const supplierService = {
  list(): Promise<Supplier[]> {
    return listSuppliersApi()
  },
  getById(id: string): Promise<Supplier | null> {
    return getSupplierApi(id)
  },
  create(input: SupplierInput): Promise<Supplier> {
    return createSupplierApi(input)
  },
  update(id: string, input: SupplierInput): Promise<Supplier> {
    return updateSupplierApi(id, input)
  },
  delete(id: string): Promise<void> {
    return deleteSupplierApi(id)
  },
  setStatus(id: string, status: SupplierStatus): Promise<Supplier> {
    return setSupplierStatusApi(id, status)
  },
  /** Nhóm hàng = unique categories derived from current quote formats. */
  listCategories(): GoodsCategory[] {
    return liveCategories().filter((c) => c.isActive)
  },
  listPaymentTerms(): PaymentTerm[] {
    return PAYMENT_TERMS.filter((t) => t.isActive)
  },
  getCategory(id: string): GoodsCategory | undefined {
    return liveCategories().find((c) => c.id === id)
  },
  getPaymentTerm(id: string): PaymentTerm | undefined {
    return PAYMENT_TERMS.find((t) => t.id === id)
  },
  categoryLabels(ids: string[]): string {
    const cats = liveCategories()
    return ids
      .map((id) => cats.find((c) => c.id === id)?.name ?? id)
      .join(', ')
  },
}

export type {
  GoodsCategory,
  PaymentTerm,
  Supplier,
  SupplierInput,
  SupplierStatus,
} from './types'
export { SUPPLIER_STATUS_LABEL } from './types'
export { GOODS_CATEGORIES, PAYMENT_TERMS } from './masters'
export {
  supplierFormatService,
  categoriesFromFormats,
  filterFormatsBySupplierCategories,
  categoryFromFormatName,
} from './supplierFormatService'
export { deleteSupplierApi } from './apiClient'
